import confetti from './confetti.json';
// import goldenShower from './goldenShower.json';
// import goldenShowerDesktop from './goldenShower.desktop.json';
import emptyAnimation from './empty.json';

export default {
  confetti: () => Promise.resolve(confetti),
  // goldenShower: {
  //   mobile: () => Promise.resolve(goldenShower),
  //   tablet: () => Promise.resolve(goldenShower),
  //   desktop: () => Promise.resolve(goldenShowerDesktop),
  goldenShower: {
    mobile: () => Promise.resolve(emptyAnimation),
    tablet: () => Promise.resolve(emptyAnimation),
    desktop: () => Promise.resolve(emptyAnimation),
  },
};
